import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import './qfaa-pricing.css';

const CHECK = (
  <span className="check">
    <svg viewBox="0 0 24 24" fill="none" stroke="#7ff0b0" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 13l4 4L19 7" />
    </svg>
  </span>
);

const money = (n) =>
  `$${Number(n).toLocaleString('en-US')}`;
const moneyC = (n) =>
  `$${Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const SS_INIT = 797;
const PAYG_TOTAL = 12688;

const SP_TIERS = {
  1: { price: 12000, risk: 500, echoM: 197, ssM: 157 },
  2: { price: 19900, risk: 1000, echoM: 347, ssM: 297 },
  3: { price: 31000, risk: 2000, echoM: 597, ssM: 497 },
};

// Oscar Kajabi checkouts for QFAA + Stripe Payment Links for à-la-carte (from qfaa-pricing.html)
const PAYMENT_LINKS = {
  'qfaa-single': {
    1: { monthly: 'https://www.jtncgroup.com/offers/fpo7RSyf/checkout' },
    2: { monthly: 'https://www.jtncgroup.com/offers/4tZXeLMx/checkout' },
    3: { monthly: 'https://www.jtncgroup.com/offers/eoVrchKa/checkout' },
  },
  'qfaa-payg': {
    0: { monthly: 'https://www.jtncgroup.com/offers/xKznSuiY/checkout' },
  },
  superstars: {
    157: {
      monthly: 'https://buy.stripe.com/aFa28s3dm8pZ64kfJX6EU0e',
      annual: 'https://buy.stripe.com/eVq3cw9BK6hR2S88hv6EU0M',
    },
    297: {
      monthly: 'https://buy.stripe.com/9B68wQ15egWvdwMcxL6EU0Q',
      annual: 'https://buy.stripe.com/aFadRag0821BakA9lz6EU0N',
    },
    497: {
      monthly: 'https://buy.stripe.com/7sY8wQaFO6hRfEU2Xb6EU0P',
      annual: 'https://buy.stripe.com/4gMeVeeW4eOn3Wc9lz6EU0O',
    },
  },
  'echo-sqq': {
    197: {
      monthly: 'https://buy.stripe.com/cNi6oI9BK7lV64k0P36EU0k',
      annual: 'https://buy.stripe.com/8x200k6pydKjfEU2Xb6EU0E',
    },
    347: {
      monthly: 'https://buy.stripe.com/00w5kEcNWcGf9gwbtH6EU0C',
      annual: 'https://buy.stripe.com/8x29AUcNWeOn2S8fJX6EU0F',
    },
    597: {
      monthly: 'https://buy.stripe.com/bJe00kcNW5dN50g41f6EU0D',
      annual: 'https://buy.stripe.com/fZu4gA01a35FeAQ8hv6EU0G',
    },
  },
  'echo-spx': {
    297: {
      monthly: 'https://buy.stripe.com/fZu00k8xGgWv50g2Xb6EU0r',
      annual: 'https://buy.stripe.com/5kQbJ28xGdKj50g0P36EU0J',
    },
    497: {
      monthly: 'https://buy.stripe.com/00w9AUcNW49J2S8apD6EU0L',
      annual: 'https://buy.stripe.com/7sYbJ215e49J0K0eFT6EU0I',
    },
    797: {
      monthly: 'https://buy.stripe.com/28E6oI4hqfSr9gw55j6EU0K',
      annual: 'https://buy.stripe.com/5kQdRabJScGf3Wc55j6EU0H',
    },
  },
  'msi-pai': {
    47: { monthly: 'https://buy.stripe.com/9B6cN6eW449JdwM0P36EU0z' },
    247: { monthly: 'https://buy.stripe.com/aFadRacNW7lVdwMapD6EU0A' },
    397: { monthly: 'https://buy.stripe.com/14A4gA4hq49JakA1T76EU0B' },
  },
};

// Superstars annual = 9 months at tier rate + initiation (no separate initiation on annual)
const superstarsAnnualYearly = (monthly) => monthly * 9 + SS_INIT;

const ALA_CARTE = [
  {
    id: 'superstars',
    name: 'Quantum Superstars',
    featured: false,
    initiation: '$797 initiation fee (covers first month)',
    tiers: [
      { value: 157, label: 'Tier 1 · up to $500 risk/trade' },
      { value: 297, label: 'Tier 2 · up to $1,000 risk/trade' },
      { value: 497, label: 'Tier 3 · up to $2,000 risk/trade' },
    ],
    features: [
      '100% automated trades',
      'Trades weekly options across 120 stocks',
      "Signals from JTNC's proprietary algorithm",
      'Manually override the bot at any time',
    ],
  },
  {
    id: 'echo-sqq',
    name: 'Quantum Echo · SPY & QQQ',
    featured: true,
    initiation: null,
    tiers: [
      { value: 197, label: 'Tier 1 · up to $300 risk/trade' },
      { value: 347, label: 'Tier 2 · up to $600 risk/trade' },
      { value: 597, label: 'Tier 3 · up to $1,200 risk/trade' },
    ],
    features: [
      '100% automated SPY & QQQ trades',
      '1 DTE contracts for more time to run',
      'Insight into current SPY & QQQ positions and trade log',
      'Manually override the bot at any time',
    ],
  },
  {
    id: 'echo-spx',
    name: 'Quantum Echo · SPX',
    featured: false,
    initiation: null,
    tiers: [
      { value: 297, label: 'Tier 1 · up to $500 risk/trade' },
      { value: 497, label: 'Tier 2 · up to $1,000 risk/trade' },
      { value: 797, label: 'Tier 3 · up to $2,000 risk/trade' },
    ],
    features: [
      '100% automated SPX trades',
      'The same Quantum engine, on SPX options',
      'Insight into current SPX positions and trade log',
      'Manually override the bot at any time',
    ],
  },
];

const MSI_OPTIONS = [
  { value: 47, mo: '47.00', note: 'Billed monthly · cancel anytime', label: 'Monthly — $47.00/mo' },
  { value: 247, mo: '41.17', note: '$247 billed every 6 months · save 12%', label: '6 months — $41.17/mo · save 12%' },
  { value: 397, mo: '33.08', note: '$397 billed yearly · save 30%', label: '1 year — $33.08/mo · save 30%' },
];

const openCheckout = (url) => {
  if (!url) {
    console.warn('[checkout] no payment link configured');
    return;
  }
  window.open(url, '_blank', 'noopener');
};

const PricingPage = () => {
  const [annual, setAnnual] = useState(false);
  const [spTier, setSpTier] = useState(1);
  const [planTiers, setPlanTiers] = useState({
    superstars: 157,
    'echo-sqq': 197,
    'echo-spx': 297,
  });
  const [msiPeriod, setMsiPeriod] = useState(47);

  useEffect(() => {
    const id = 'qfaa-pricing-fonts';
    if (document.getElementById(id)) return;
    const link = document.createElement('link');
    link.id = id;
    link.rel = 'stylesheet';
    link.href =
      'https://fonts.googleapis.com/css2?family=Poppins:wght@500;600;700;800&family=Inter:wght@400;500;600&display=swap';
    document.head.appendChild(link);
  }, []);

  const sp = useMemo(() => {
    const d = SP_TIERS[spTier];
    const echoV = d.echoM * 3;
    const ssV = SS_INIT + d.ssM * 2;
    const bonus = echoV + ssV;
    const eff = d.price - bonus;
    const base = SP_TIERS[1].price / SP_TIERS[1].risk;
    const off = Math.round(((base - d.price / d.risk) / base) * 100);
    const less = PAYG_TOTAL - eff;
    const pct = Math.round((less / PAYG_TOTAL) * 100);
    return { d, echoV, ssV, bonus, eff, off, less, pct };
  }, [spTier]);

  const msiOpt = MSI_OPTIONS.find((o) => o.value === msiPeriod) || MSI_OPTIONS[0];

  return (
    <div className="qfaa-pricing-page">
      <header className="topbar">
        <div className="wrap">
          <nav className="nav">
            <Link className="brand" to="/" aria-label="JTNC Group home">
              <img className="logo" src="/logojt.png" alt="JTNC Group logo" />
              <span className="brand-name">JTNC Group, LLC</span>
            </Link>
          </nav>
        </div>
      </header>

      <main>
        <section className="phead">
          <div className="wrap">
            <span className="eyebrow">
              <span className="dot" /> Quantum Flo Auto Algo
            </span>
            <h1>QFAA — our flagship, fully automated.</h1>
            <p>
              Quantum Flo Auto Algo is the engine every other Quantum product is built on. Choose how
              you&apos;d like to pay, then scroll down for our à-la-carte products.
            </p>
          </div>
        </section>

        <section className="wrap">
          <div className="qfaa-grid">
            {/* Single Pay */}
            <article className="qfaa featured" data-plan="qfaa-single">
              <span className="pop">Best value</span>
              <div className="plan-kicker">QFAA · Single Pay</div>
              <h3>Pay once, run for the year</h3>
              <div className="price">
                <span className="amt">{money(sp.d.price)}</span>
                <span className="per">one-time</span>
              </div>
              <div className="initiation">One payment · covers your full 12 months</div>
              <div className="mult-label" style={{ marginTop: 12 }}>
                Choose your tier{' '}
                <span
                  className="i"
                  title="Higher tiers raise your maximum risk per trade — and your free Quantum Echo & Superstars move up to match."
                >
                  i
                </span>
              </div>
              <select
                className="mult"
                aria-label="QFAA Single Pay tier"
                value={spTier}
                onChange={(e) => setSpTier(Number(e.target.value))}
              >
                <option value={1}>Tier 1 · up to $500 risk/trade</option>
                <option value={2}>Tier 2 · up to $1,000 risk/trade</option>
                <option value={3}>Tier 3 · up to $2,000 risk/trade</option>
              </select>
              <div className="qfaa-inst">
                Trades <b>SPY</b> &amp; <b>QQQ</b>
                <span className="soon">SPX when available</span>
              </div>
              <div className="qfaa-bonus">
                <div className="bonus-top">
                  <span className="bonus-badge">Free only with Single Pay</span>
                  <span className="bonus-sum">{money(sp.bonus)} value</span>
                </div>
                <ul className="vstack">
                  <li>
                    <div className="vs-row">
                      <span className="vs-name">
                        Quantum Echo — 90 days <em>· Tier {spTier}</em>
                      </span>
                      <span className="vs-val">{money(sp.echoV)}</span>
                    </div>
                    <div className="vs-sub">
                      {money(sp.d.echoM)}/mo × 3
                    </div>
                  </li>
                  <li>
                    <div className="vs-row">
                      <span className="vs-name">
                        Quantum Superstars — 90 days <em>· Tier {spTier}</em>
                      </span>
                      <span className="vs-val">{money(sp.ssV)}</span>
                    </div>
                    <div className="vs-sub">
                      {money(SS_INIT)} initiation + {money(sp.d.ssM)}/mo × 2
                    </div>
                  </li>
                </ul>
              </div>
              <div className="qfaa-net">
                <div className="net-row">
                  <span>Your effective cost</span>
                  <b>{money(sp.eff)}</b>
                </div>
                {spTier === 1 ? (
                  <div className="net-cmp">
                    {money(sp.d.price)} − {money(sp.bonus)} in Echo &amp; Superstars value —{' '}
                    <b>{sp.pct}% cheaper</b> than Pay As You Go ({money(sp.less)} less than{' '}
                    {money(PAYG_TOTAL)})
                  </div>
                ) : null}
                {spTier > 1 ? (
                  <div className="sp-disc">
                    ★ {sp.off}% better value than Tier&nbsp;1 <em>per $ of risk</em>
                  </div>
                ) : null}
              </div>
              <div className="qfaa-both">
                Plus <b>Quantum MSI &amp; PAI free for 1 year</b> ($396.96) — included with both plans.
              </div>
              <ul className="feats">
                <li>{CHECK}The complete Quantum Flo Auto Algo engine</li>
                <li>{CHECK}100% automated in your own Tradier account</li>
                <li>{CHECK}Pause, stop, or take over any trade at any time</li>
              </ul>
              <button
                type="button"
                className="btn btn-sub"
                onClick={() => openCheckout(PAYMENT_LINKS['qfaa-single'][spTier]?.monthly)}
              >
                Get QFAA — Single Pay
              </button>
            </article>

            {/* Pay As You Go */}
            <article className="qfaa" data-plan="qfaa-payg">
              <div className="plan-kicker">QFAA · Pay As You Go</div>
              <h3>Spread it over the year</h3>
              <div className="price">
                <span className="amt">$2,799</span>
                <span className="per">down</span>
              </div>
              <div className="initiation">
                then $899/mo × 11 — first payment 60 days after enrollment
              </div>
              <div className="qfaa-tier">
                Tier 1 · up to <b>$500</b> risk per trade
                <Link className="up" to="/upgrade">
                  Upgrades after paid in full →
                </Link>
              </div>
              <div className="qfaa-inst">
                Trades <b>SPY</b> &amp; <b>QQQ</b>
                <span className="soon">SPX when available</span>
              </div>
              <div className="qfaa-bonus">
                <div className="bonus-top">
                  <span className="bonus-badge">Included free</span>
                  <span className="bonus-sum">$396.96 / yr value</span>
                </div>
                <ul className="vstack">
                  <li>
                    <div className="vs-row">
                      <span className="vs-name">Quantum MSI &amp; PAI — full term</span>
                      <span className="vs-val">$396.96/yr</span>
                    </div>
                    <div className="vs-sub">$33.08/mo × 12, for every year you stay subscribed</div>
                  </li>
                </ul>
              </div>
              <ul className="feats">
                <li>{CHECK}The complete Quantum Flo Auto Algo engine</li>
                <li>{CHECK}100% automated in your own Tradier account</li>
                <li>{CHECK}Pause, stop, or take over any trade at any time</li>
              </ul>
              <button
                type="button"
                className="btn btn-sub"
                onClick={() => openCheckout(PAYMENT_LINKS['qfaa-payg'][0]?.monthly)}
              >
                Get QFAA — Pay As You Go
              </button>
            </article>
          </div>

          <div className="qfaa-reqs">
            <div className="req">
              <span className="ri">i</span>
              <div>
                <b>Tradier account required.</b> You must open your Tradier brokerage account through
                one of our links — required for every Quantum product. Each includes free cash and
                commission-free trading for a period, based on your account size.
                <div className="req-links">
                  <a href="https://trade.tradier.com/wl2/" target="_blank" rel="noopener noreferrer">
                    $5,000 minimum account →
                  </a>
                  <a href="https://trade.tradier.com/jtnc/" target="_blank" rel="noopener noreferrer">
                    $35,000 minimum account →
                  </a>
                </div>
              </div>
            </div>
            <div className="req">
              <span className="ri">i</span>
              <div>
                <b>Account size.</b> We recommend starting QFAA with <b>$10,000</b>. You can start
                with as little as <b>$5,000</b> if you&apos;d prefer to start smaller.
              </div>
            </div>
          </div>

          <div className="starter-head" style={{ marginTop: 52 }}>
            <span className="st-line" />
            <span className="st-or">
              Want to test Quantum Flo technology before committing? Build your own plan below
            </span>
            <span className="st-line" />
          </div>

          <div className="billing">
            <span className={`opt ${!annual ? 'active' : ''}`}>Monthly</span>
            <label className="switch">
              <input
                type="checkbox"
                checked={annual}
                onChange={(e) => setAnnual(e.target.checked)}
                aria-label="Toggle annual billing"
              />
              <span className="slider" />
            </label>
            <span className={`opt ${annual ? 'active' : ''}`}>
              Annually <span className="free">2 months free</span>
            </span>
          </div>
        </section>

        <section className="wrap">
          <div className="plans">
            {ALA_CARTE.map((plan) => {
              const monthly = planTiers[plan.id];
              const isSuperstarsAnnual = plan.id === 'superstars' && annual;
              const yearlyTotal = isSuperstarsAnnual
                ? superstarsAnnualYearly(monthly)
                : monthly * 10;
              const displayAmt = annual
                ? moneyC(yearlyTotal / 12)
                : money(monthly);
              const saveNote = annual
                ? isSuperstarsAnnual
                  ? `${money(yearlyTotal)} billed yearly · no separate initiation fee`
                  : `${money(yearlyTotal)} billed yearly · save ${money(monthly * 2)} (17%)`
                : '';
              const initiationText = isSuperstarsAnnual
                ? '\u00a0'
                : plan.initiation || '\u00a0';

              return (
                <article
                  key={plan.id}
                  className={`plan ${plan.featured ? 'featured' : ''}`}
                  data-plan={plan.id}
                >
                  <h3>{plan.name}</h3>
                  <div className="price">
                    <span className="amt">{displayAmt}</span>
                    <span className="per">/month</span>
                  </div>
                  <div className="initiation">{initiationText}</div>
                  <div className="save-note">{saveNote}</div>
                  <div className="mult-label">
                    Choose your tier{' '}
                    <span
                      className="i"
                      title="Tiers set the maximum risk per trade. Higher tiers allow larger position sizing."
                    >
                      i
                    </span>
                  </div>
                  <select
                    className="mult"
                    aria-label={`${plan.name} tier`}
                    value={monthly}
                    onChange={(e) =>
                      setPlanTiers((prev) => ({
                        ...prev,
                        [plan.id]: Number(e.target.value),
                      }))
                    }
                  >
                    {plan.tiers.map((t) => (
                      <option key={t.value} value={t.value}>
                        {t.label}
                      </option>
                    ))}
                  </select>
                  <ul className="feats">
                    {plan.features.map((f) => (
                      <li key={f}>
                        {CHECK}
                        {f}
                      </li>
                    ))}
                  </ul>
                  <button
                    type="button"
                    className="btn btn-sub"
                    onClick={() => {
                      const period = annual ? 'annual' : 'monthly';
                      openCheckout(PAYMENT_LINKS[plan.id]?.[monthly]?.[period]);
                    }}
                  >
                    Subscribe Now
                  </button>
                </article>
              );
            })}
          </div>
        </section>

        <section className="wrap">
          <div className="starter-head">
            <span className="st-line" />
            <span className="st-or">Not ready to automate?</span>
            <span className="st-line" />
          </div>

          <article className="plan starter" data-plan="msi-pai">
            <div className="st-main">
              <div className="plan-kicker">Indicator/Signal Package</div>
              <h3>Quantum MSI &amp; Quantum PAI</h3>
              <p className="st-desc">
                Trade the Quantum edge yourself. Get our two TradingView indicators, daily market
                reports, and live Superstars signals — then automate whenever you&apos;re ready.
              </p>
              <ul className="feats st-feats">
                <li>
                  <span className="check">✓</span>Full access to Quantum MSI
                </li>
                <li>
                  <span className="check">✓</span>Full access to Quantum PAI
                </li>
                <li>
                  <span className="check">✓</span>Premarket report — daily SPY levels
                </li>
                <li>
                  <span className="check">✓</span>Daily post-market report — recap + next-day plan
                </li>
                <li>
                  <span className="check">✓</span>Quantum Superstars signals
                </li>
              </ul>
            </div>
            <div className="st-buy">
              <div className="price">
                <span className="amt">${msiOpt.mo}</span>
                <span className="per">/month</span>
              </div>
              <div className="initiation">{msiOpt.note}</div>
              <div className="mult-label">
                Choose your billing period{' '}
                <span className="i" title="Longer terms lower your effective monthly price.">
                  i
                </span>
              </div>
              <select
                className="mult"
                aria-label="Quantum MSI & Quantum PAI billing period"
                value={msiPeriod}
                onChange={(e) => setMsiPeriod(Number(e.target.value))}
              >
                {MSI_OPTIONS.map((o) => (
                  <option key={o.value} value={o.value}>
                    {o.label}
                  </option>
                ))}
              </select>
              <button
                type="button"
                className="btn btn-sub"
                onClick={() => openCheckout(PAYMENT_LINKS['msi-pai'][msiPeriod]?.monthly)}
              >
                Subscribe Now
              </button>
            </div>
          </article>
        </section>

        <footer>
          <div className="wrap">
            <div className="foot">
              <div className="links">
                <Link to="/terms">Terms of Use</Link>
                <Link to="/privacy">Privacy Policy</Link>
                <Link to="/disclaimer">Disclaimer</Link>
              </div>
              <div className="integ">
                Integrated with
                <span className="chip">
                  <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <circle cx="16" cy="16" r="15" fill="#1769d6" />
                    <path
                      d="M9 19 L15 12 L19 16 L24 9"
                      fill="none"
                      stroke="#ff7a18"
                      strokeWidth="2.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <circle cx="24" cy="9" r="2.4" fill="#ff7a18" />
                  </svg>
                  <span className="word">
                    tradier<b>.</b>
                  </span>
                </span>
              </div>
            </div>
            <p className="disc">
              Trading in securities and options carries substantial risk and is not suitable for
              every investor. Prices shown are subscription fees for automated trading software and
              do not include brokerage commissions or market data. Past performance is not indicative
              of future results. The initiation fee for Quantum Superstars covers the first month of
              service.
            </p>
            <p className="copy">© 2026 JTNCgroup.com. All rights reserved.</p>
          </div>
        </footer>
      </main>
    </div>
  );
};

export default PricingPage;
